import { useState } from 'react';

import type { MainMenuSubmenu } from '@crehana/web/';
import WrappedMainMenu from '@crehana/web/MainMenu';

import MainMenuWrapper from './MainMenuWrapper';
import type { MainMenuWithTopBannerProps } from './types';

const MainMenu: React.FC<
  React.PropsWithChildren<MainMenuWithTopBannerProps>
> = props => {
  const [isTopBannerOpen, setIsTopBannerOpen] = useState(false);

  const onChangeActiveSubmenu = (activeSubmenu?: MainMenuSubmenu) => {
    const topBannerContainer = document.getElementById(
      'top-banner-container',
    ) as HTMLDivElement | undefined;

    if (topBannerContainer) {
      topBannerContainer.style.display =
        activeSubmenu === 'search' ? 'none' : 'block';
    }
  };

  return (
    <MainMenuWrapper
      countryPrefix={props.countryPrefix}
      amplitudePageName={props.amplitudePageName}
      onToggleTopBanner={setIsTopBannerOpen}
      position={props.position}
      {...props.topBannerProps}
      isAllAccessEnabled={props.isAllAccessEnabled}
    >
      <WrappedMainMenu
        topBannerIsOpen={isTopBannerOpen}
        {...props}
        onChangeActiveSubmenu={onChangeActiveSubmenu}
      />
    </MainMenuWrapper>
  );
};

export default MainMenu;
